import { createSelector } from 'reselect';

import type Shipment from '~/types/Shipment';

import { type ApplicationState } from '../store';
import { getHiddenRates } from './rates.selectors';

const getShipmentsStore = (state: ApplicationState) => state.shipments;

const getShipmentIdFromProps = (_, props: { shipmentId: string }): string =>
  props.shipmentId ? props.shipmentId : '';

export const getShipmentLoadingStates = createSelector(
  getShipmentsStore,
  (shipmentsStore) => shipmentsStore.loadState,
);

export const getShipmentsData = createSelector(
  getShipmentsStore,
  getHiddenRates,
  (shipmentsStore, hiddenRates): { [shipmentObjectId: string]: Shipment } =>
    Object.fromEntries(
      Object.entries(shipmentsStore.data).map(([objectId, shipment]) => [
        objectId,
        {
          ...shipment,
          rates: shipment.rates.filter((rate) => !hiddenRates.includes(rate.objectId)),
        },
      ]),
    ),
);

export const getShipmentByShipmentId = createSelector(
  getShipmentsData,
  getShipmentIdFromProps,
  (shipmentsData, shipmentId): Maybe<Shipment> => shipmentsData[shipmentId],
);

export const getShipmentIsLoading = createSelector(
  getShipmentLoadingStates,
  getShipmentIdFromProps,
  (loadingState, shipmentObjectId): boolean => !!loadingState[shipmentObjectId],
);
